module.exports = __webpack_public_path__ + "media/home-button-mp3.63fccf63.mp3";